/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {  Controller, useForm } from 'react-hook-form';
import { Button, Grid, Modal, TextField, Typography } from '@mui/material';
import styled from 'styled-components';
import Swal from 'sweetalert2'
import InputMask from 'react-input-mask';

import { useAuth } from '../../providers/AuthProvider';
import { CTA } from '../Common/CTA';
import { FormChangePassword } from './FormChangePassword';
import ApiService from '../../helpers/ApiService';

const FormMyAccountContainer = styled.div`
  background-color: var(--primary);
  border-radius: 1rem;
  padding: 1.5rem;
  /* margin-top: 1.5rem; */

  form {
    .MuiInputBase-root {
      color: var(--bluegray-600);
      background-color: var(--white);
      margin-bottom: 0.5rem;
    }
    .MuiInputBase-root.Mui-disabled {
      color: var(--bluegray-600);
      background-color: var(--gray-300) !important;
      cursor: not-allowed;
    }
    
    .MuiFormHelperText-root {
      color: var(--white);
    }
    .MuiFormControlLabel-label  {
      color: var(--white);
    }
  }
`;

export const FormMyAccount = () => {
  const [ openModal, setOpenModal ] = useState(false);
  const [ isLoading, setIsLoading ] = useState(true);
  const { user, token, setToken } = useAuth();
  const { register, handleSubmit, formState: {errors}, control, setValue } = useForm();

  useEffect( () => {
    let mounted = true;
    if (mounted) {
      setValue('name', user.name)
      setValue('cellphone', user.cellphone)
    }
    return () => mounted = false;
  }, [setValue, user]);

  useEffect(() => {
    let mounted = true;
    if(mounted) {
      register('name');
      register('email');
      register('cpf');
      register('cellphone');
      register('password');
      register('confirmPass');
      register('acceptTerms');
    }
  
    return () => mounted = false;
  }, []);

  const onSave = async data => {
    setIsLoading(true);

    ApiService.put('user/update', data, token).then( (result) => {
      if( result.status === 200) {
        setIsLoading(true);
        setToken(result.data.token);

        Swal.fire({
          title: `Beleza!`,
          text: 'Seu cadastro foi atualizado com sucesso!',
          icon: 'success',
          confirmButtonText: 'Obrigado'
        });
      }
    }).catch((error) => {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Ocorreu um erro desconhecido. Tente novamente mais tarde.',
        confirmButtonText: "Entendi"
      });
      setIsLoading(false);
    });
  }
  
  const handleCloseModal = () => {
    setOpenModal(false);
  }

  return (
    <FormMyAccountContainer>
      <form onSubmit={handleSubmit(onSave)}>
        <Grid container spacing={1}>
          <Grid item sm={12} xs={12}>
            <Typography variant="caption" className="white--text bold-text opacity" mb={1}>
              Nome
            </Typography>
            <Controller
              name='name'
              control={control}
              defaultValue=""
              render={ ({ field: {onChange, value}, fieldState: { error }}) => (
                <TextField
                  id="MyAccountName"
                  variant="outlined"
                  fullWidth
                  placeholder="Nome completo"
                  value={value}
                  onChange={(e) => {
                    onChange(e);
                    isLoading && setIsLoading(false);
                  }}
                  error={!!error}
                  helperText={errors.name && "Nome obrigatório"}
                />
              )}
              rules={{ required: 'Nome obrigatório' }}
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <Typography variant="caption" className="white--text bold-text opacity" mb={1}>
              E-mail
            </Typography>
            <Controller
              name="email"
              control={control}
              defaultValue={user.email}
              render={ ({ field: { onChange, value }, fieldState: { error } }) => (
                <TextField
                  id='MyAccountEmail'
                  type="email"
                  placeholder="E-mail"
                  variant="outlined"
                  fullWidth
                  onChange={onChange}
                  value={user.email || value}
                  error={!!error}
                  helperText={error ? "E-mail inválido" : null}
                  disabled
                />
              )}
              register
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <Typography variant="caption" className="white--text bold-text opacity" mb={1}>
              CPF
            </Typography>
            <Controller
              name="cpf"
              control={control}
              defaultValue=""
              render={ ({ field: { onChange, value }, fieldState: { error } }) => (
                <TextField
                  id='MyAccountCpf'
                  placeholder="CPF"
                  variant="outlined"
                  fullWidth
                  value={user.cpf || value}
                  error={!!error}
                  helperText={error ? "CPF inválido" : null}
                  disabled
                />
              )}
              register
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <Typography variant="caption" className="white--text bold-text opacity" mb={1}>
              Telefone
            </Typography>
            <Controller
              name="cellphone"
              control={control}
              rules={{ required: 'Telefone obrigatório', pattern: /^\([0-9]+\) [0-9]+-[0-9]+$/i }}
              render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
                <InputMask
                  mask="(99) 99999-9999"
                  maskChar=" "
                  onChange={onChange}
                  value={value}
                >
                  { () => (
                    <div>
                      <TextField
                        placeholder="Telefone"
                        variant="outlined"
                        fullWidth
                        type="tel"
                        onChange={(e) => {
                          onChange(e);
                          isLoading && setIsLoading(false);
                        }}
                        error={!!error}
                        helperText={error ? "Telefone inválido" : null}
                        inputRef={ref}
                      />
                    </div>
                  )}
                </InputMask>
              )}
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <Button variant="text" size='small' className="white--text bold-text" onClick={() => setOpenModal(true)}>
              Alterar senha
            </Button>
          </Grid>
          <Grid item sm={12} xs={12} align="center">
            <CTA type="submit" disabled={isLoading}>
              Salvar alterações
            </CTA>
          </Grid>
        </Grid>
      </form>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
      >
        <>
          <FormChangePassword onClose={handleCloseModal} />
        </>
      </Modal>
    </FormMyAccountContainer>
  )
}